import { PermissionEnum } from '../enums/PermissionEnum';

export function toPermissionValueSet(permissionNames?: string[]): Set<PermissionEnum> {
  const values = (permissionNames ?? [])
    .map((name) => PermissionEnum[name as keyof typeof PermissionEnum])
    .filter((value): value is PermissionEnum => typeof value === 'number');
  return new Set(values);
}
